export default {
  computed: {
    // Return login state
    user_loggedIn: function() { return this.$store.getters.userInfo && this.$store.getters.userInfo.id; },

    // Return logged user id
    user_id: function() { return (this.$store.getters.userInfo) ? this.$store.getters.userInfo.id : 0; },

    // Return logged user name
    user_name: function() { return (this.$store.getters.userInfo) ? this.$store.getters.userInfo.name : ''; },

    // Return logged user role
    user_role: function() { return (this.$store.getters.userInfo) ? this.$store.getters.userInfo.group : 0; },

    // Return true if user role is admin
    user_isAdministrator: function() { return (this.$store.getters.userInfo) ? this.$store.getters.userInfo.group > 1 : false; },

    // Return default service for the user
    user_services: function() {
      const services = (this.$store.getters.userInfo) ? this.$store.getters.userInfo.services : '';
      return (services) ? services.split(',').map(service => parseInt(service)) : [];
    },
  },

  methods: {
    // Set new user info
    user_set: function(data) { this.$store.commit('setUserInfo', data); },

    // reset user info
    user_reset: function() { this.$store.commit('setUserInfo', null); },
  },
};
